module.exports = __webpack_public_path__ + "img/8.4be541b0.png";